import validator, { PhoneLocale } from "validator";

export const required = (subject: any) => (v: any) =>
  !!v || `${subject} is required`;
export const isMobilePhone =
  (locale: PhoneLocale = "en-US") =>
  (v: any) =>
    validator.isMobilePhone(
      locale === "en-AU" ? v.replaceAll(" ", "") : v,
      locale
    ) || "Valid mobile phone number is required";
export const isEmail = (v: any) =>
  validator.isEmail(v) || "Valid email is required";
